import * as Types from '../Constants/AllConstants';

// Get all transactions (paged)
export const GetAllTransactionsReducer = (
  state = { transactions: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.TRANSACTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.content || [],
        pages: action.payload.totalPages || 0,
        page: action.payload.number || 0,
        totalElements: action.payload.totalElements || 0,
        size: action.payload.size || 15,
      };
    case Types.TRANSACTIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_LIST_RESET:
      return { transactions: [], pages: 0, page: 0 };
    default:
      return state;
  }
};

// Get transaction details
export const TransactionDetailsReducer = (state = { transaction: null }, action) => {
  switch (action.type) {
    case Types.TRANSACTION_DETAILS_REQUEST:
      return { loading: true };
    case Types.TRANSACTION_DETAILS_SUCCESS:
      return { loading: false, transaction: action.payload };
    case Types.TRANSACTION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTION_DETAILS_RESET:
      return { transaction: null };
    default:
      return state;
  }
};
